import { PayloadAction, createSlice } from "@reduxjs/toolkit";
const quickActionsSlice = createSlice({
  name: "quickActions",
  initialState: () => {
    const initialState = { 
      isLoginSuccess:false,
      page_name:""
};
    return initialState;
  },
  reducers: {
    setIsLoginSuccess(state, action: PayloadAction<boolean>) {
      state.isLoginSuccess = action.payload;
      return state;
    },
    setPageName(state, action: PayloadAction<string>) {
      state.page_name = action.payload;
      return state;
  }}
});

export const {
  setIsLoginSuccess,
  setPageName
} = quickActionsSlice.actions;

export default quickActionsSlice;
